// Один баббл сообщения тикета.
// Стили:
//   user   — справа, синий градиент, белый текст
//   mod    — слева, белый фон, тёмный текст
//   system — по центру, серый курсив
//   internal (только админ) — жёлтый фон + замок
import React from "react";
import { LockClosedIcon } from "../icons/LockClosedIcon";
import { attachmentUrl } from "../../api/tickets";

function formatTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const now = new Date();
    const sameDay =
      d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() &&
      d.getDate() === now.getDate();
    if (sameDay) {
      return d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
    }
    return d.toLocaleString("ru-RU", {
      day: "2-digit", month: "2-digit",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

const KIND_LABEL = {
  user: "Ты",
  mod: "МИН",
  system: "Система",
};

export default function TicketMessageItem({ message }) {
  const kind = message.author_kind || "user";
  const isInternal = !!message.is_internal;
  const bubbleCls =
    "sup-msg__bubble" + (isInternal ? " sup-msg__bubble--internal" : "");

  return (
    <div className={`sup-msg sup-msg--${kind}`}>
      {kind !== "system" && (
        <div className="sup-msg__meta">
          {KIND_LABEL[kind]} · {formatTime(message.created_at)}
        </div>
      )}
      <div className={bubbleCls}>
        {isInternal && (
          <div className="sup-msg__internal-mark">
            <LockClosedIcon size={12} /> Внутренняя заметка
          </div>
        )}
        {message.text}
        {message.attachments && message.attachments.length > 0 && (
          <div className="sup-msg__attach-row" style={{ marginTop: 8 }}>
            {message.attachments.map((a) => {
              // Используем клиентский attachmentUrl — он подмешает ?token=
              // (бэк-эндпоинт /attachments/<id> требует JWT, а <img src=…>
              // сам header Authorization не отправляет).
              const url = attachmentUrl(a.id);
              return (
                <a
                  key={a.id}
                  className="sup-msg__attach"
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  title={a.name}
                >
                  {a.mime && a.mime.startsWith("image/") ? (
                    <img src={url} alt={a.name} />
                  ) : a.mime === "video/mp4" ? (
                    <video src={url} controls />
                  ) : (
                    <span style={{ padding: 6, fontSize: 12 }}>{a.name}</span>
                  )}
                </a>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
